import CityCard from "./CityCard";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MultiViewSlider, OnePageSlider } from "reusableComponents";
import { getCities, getPlaceUsagesForPresentation, getTotalSpaces } from "services/homePage.services";
import { useLanguage } from "context/languageContext";
import styles from "./styles.module.scss";

const CitiesSection = () => {
  const [t] = useTranslation("global");
  const { language } = useLanguage();
  const [cities, setCities] = useState([]);
  const [totalSpaces, setTotalSpaces] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const country = language === 'es' ? 'Spain' : language === 'be' ? 'Belgium' : 'France';

 useEffect(() => {
    const fetchData = async () => {
      setError(null);
      try {
        // Fetch both cities and total spaces in parallel
        const [fetchedCities, fetchedTotalSpaces] = await Promise.all([
          getPlaceUsagesForPresentation(language),
          getTotalSpaces(language)
        ]);
        
        setCities(fetchedCities);
        setTotalSpaces(fetchedTotalSpaces.total);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [language]);

  if (loading) {
    return <div></div>;
  }

  if (error) {
    return <div></div>;
  }

  const citiesRenderer = cities?.map((city) => (
    <CityCard city={city} key={city.title} />
  ));
  
  return (
      <div className={`mediumContainer ${styles.citiesSectionContainer}`}>
    <section className={styles.citiesSection}>
        <div className={styles.sectionContent}>
          <div className={styles.textContent}>
            <h2 className={styles.heading} dangerouslySetInnerHTML={{__html: t("home.towns")}}/>
            <p className={styles.description} dangerouslySetInnerHTML={{__html: t("home.towns_description", {totalSpaces: totalSpaces})}}>
            </p>
            <a className={styles.seeAllLink} href={`/search?country=${country}`}> {t("home.seeplace")}</a>
          </div>
          
          <div className={styles.sliderContent}>
            <div className={styles.sliderDesktop}>
              <MultiViewSlider
                slidesNum={3}
                arrowRight="8px"
                arrowLeft="8px"
                arrowStyle="square"
  arrowBorderColor="#d1d5db" // These only affect round arrows
  arrowBackgroundColor="white" // These only affect round arrows
                key={`${language}-${cities.length}`}
              >
                {citiesRenderer}
              </MultiViewSlider>
            </div>
            <div className={styles.sliderMobile}>
   <OnePageSlider
                slidesNum={1}
                // arrowTop="10vw"
                // arrowRight="-4px"
                // arrowLeft="-4px"
                key={`${language}-${cities.length}`}
              >
                {citiesRenderer}
              </OnePageSlider>           </div>
          </div>
        </div>
    </section>
      </div>
  );
};

export default CitiesSection;